type DateKeys<T> = {
  [K in keyof T]: Date extends T[K] ? K : never;
}[keyof T];

export const parseDateField = <Obj extends object>(
  obj: Obj,
  dateKey: DateKeys<Obj>,
) => {
  if (obj[dateKey]) {
    //@ts-expect-error non-checkable by ts
    obj[dateKey] = new Date(obj[dateKey]);
  }
};
